import { render } from "./MoveModal.vue?vue&type=template&id=424d9cb9&scoped=true"
import script from "./MoveModal.vue?vue&type=script&lang=js"
export * from "./MoveModal.vue?vue&type=script&lang=js"

import "./MoveModal.vue?vue&type=style&index=0&id=424d9cb9&scoped=true&lang=css"

import exportComponent from "/home/adrianhardy/projects/Clients/O/Orchard_Crown_Ltd/ionic-storeroom/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-424d9cb9"]])

export default __exports__